<!--suppress CheckEmptyScriptTag -->
<template>
  <!--modal-->
  <div
    id="best-add-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div ref="modal" class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="exampleModalLongTitle" class="modal-title">
            {{ $t("Auto-fit Best Ads") }}
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true"> &times; </span>
          </button>
        </div>
        <div class="modal-body">
          <fields :fields="fields.all()" :model="model" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{ $t("Cancel") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSubmit">
            {{ $t("Submit") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceFormMixin from "../mixins/ResourceFormMixin";

export default {
  name: "BestAddModal",

  mixins: [ResourceFormMixin],

  mounted() {
    $("#best-add-modal").on("shown.bs.modal", this.onModalShown);
  },

  methods: {
    show() {
      $("#best-add-modal").modal({
        show: true,
      });
    },

    hide() {
      $("#best-add-modal").modal("hide");
    },

    onModalShown() {
      this.withUiBlocker(
        this.$http
          .get("searches/best-companies/create")
          .then(({ data }) => {
            this.model = data.data;
            this.setFields(data.fields);
          })
          .catch((err) => console.error(err)),
        this.$refs.modal
      );
    },

    onSubmit() {
      this.$emit("submit", this, this.model);
    },
  },
};
</script>

<style>
.wrapper {
  position: static;
}
</style>
